import { Form } from '@vivaldis/antd-ui'
import type { EmployeeInput } from '@vivaldis/graphql'
import { Step, useStep } from '../../provider/StepProvider'
import { ActionBar } from './components/ActionBar'
import { FormContent } from './components/FormContent'
import { FormProvider } from './provider/FormProvider'
import { CountryType } from '../../types/CountryType'
import { Employee } from '../../types/Employee'

interface Props {
  countries: CountryType[]
  employee: Employee
  onGoBack: () => void
  onSubmit: (employeeInput: EmployeeInput) => Promise<void>
}

export const EnterSSNStep = ({
  employee,
  onGoBack,
  onSubmit,
  countries
}: Props) => {
  const { step } = useStep()

  if (step !== Step.AddSSNStep) {
    return null
  }

  return (
    <FormProvider employee={employee} onGoBack={onGoBack} onSubmit={onSubmit}>
      <Form autoComplete="off">
        <FormContent countries={countries} />
        <ActionBar />
      </Form>
    </FormProvider>
  )
}
